export const SET_AUTH = 'SET_AUTH';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_PROFILE = 'SET_PROFILE';
export const AUTHENTICATED = 'AUTHENTICATED';
export const RESET_AUTH = 'RESET_AUTH';
